
import { defineComponent } from "vue";
import LButtom from "../LButtom/LButtom.vue";
import { mapState } from "vuex";

export default defineComponent({
  name: "LInfoLinksHome",
  components: { LButtom },
  data() {
    return {
      links: [],
      link: "",
    };
  },
  computed: {
    ...mapState(["user"]),
  },
});
